var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a17a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030e88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6273e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf152b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-.001438 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.81212846 7.61904762h-3.81356642v-3.80952381h3.81356642l-5.39850944-3.64134059.85210348-1.26329535 6.82807764 4.60559652v-4.27238915h3.80952382v4.27238915l6.82807764-4.60559652.8521035 1.26329535-5.3985095 3.64134059h3.8135665v3.80952381h-3.8135665l5.3985095 3.64134058-.8521035 1.2632954-6.82807764-4.60559659v4.27238919h-3.80952382v-4.27238919l-6.82807764 4.60559659-.85210348-1.2632954z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#db1f35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.7706591 3.77752527 7.2373513-4.76125372c.0878843-.05781669.1122589-.17593072.0544422-.26381507-.0578166-.08788435-.1759307-.11225901-.263815-.05444232l-7.2373512 4.76125373c-.0878843.05781668-.112259.17593072-.0544424.26381507.0578167.08788435.1759308.112259.2638151.05444231z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.3279734 7.98509539 6.4879093 4.37304681c.0872317.0587968.2056111.0357458.2644079-.0514859s.0357457-.2056111-.051486-.2644079l-6.4879091-4.37304688c-.0872317-.0587968-.2056112-.03574575-.264408.05148595-.0587968.08723162-.0357458.20561112.0514859.26440792z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.67960367 3.44802651-6.76743861-4.56082589c-.08723546-.05879119-.20561345-.03573255-.26440463.05150292-.05879119.08723545-.03573255.20561343.05150291.26440462l6.76743862 4.5608259c.08723546.05879118.20561344.03573254.26440462-.05150292.0587912-.08723546.03573255-.20561344-.05150291-.26440463z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.20188498 7.61548538-7.50144159 4.97460942c-.08767115.0581394-.11161133.1763423-.05347186.2640135.05813946.0876711.17634231.1116112.26401348.0534718l7.50144159-4.97460936c.08767115-.0581395.11161133-.17634232.05347187-.26401348-.05813947-.08767117-.17634233-.11161135-.26401349-.05347188z",
    mask: "url(#e)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-.00143796 6.85714286h6.85714286v4.57142854h2.2857143v-4.57142854h6.8571429v-2.28571429h-6.8571429v-4.57142857h-2.2857143v4.57142857h-6.85714286z",
    fill: "url(#d)",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.84ac8f2d1252b55755e24d00d827e42a.svg";
export { ForwardRef as ReactComponent };